export const dailyNoteFilters = Object.freeze({
  ALL: 'all',
  ONLY_NOTE: 'onlyNote',
});
